module.exports = __webpack_public_path__ + "img/weather-ray.348f5508.png";